var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _circle, _ellipse, _path7, _rect3, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 348,
    viewBox: "0 0 508 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 508,
    height: 346,
    rx: 16,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237 173L188 166L189.962 219H229.529L237 173Z",
    fill: "#F0AAA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.894 268.296C286.226 283.379 274.92 319.383 269 346H180.5L171.5 274C171.5 274 163.96 227.077 161 217.28C165.07 217.835 180.051 214.446 188 208.5C193.312 204.526 192.942 191.73 193.312 186L234.94 189V196.763C234.94 202.308 239.38 203.972 249.371 204.526C259.362 205.081 264.357 212.844 265.467 217.28C266.577 221.717 268.797 228.371 274.903 236.688C281.008 245.006 283.228 249.442 284.894 268.296Z",
    fill: "#AC725D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.061 301.981C191.807 307.515 189.492 318.632 194.85 327.001L196.245 329.179C202.395 338.784 215.746 340.466 224.086 332.687L310.604 251.988C312.648 250.081 313.809 247.411 313.809 244.616C313.809 236.551 304.811 231.751 298.112 236.242L200.061 301.981Z",
    fill: "#F0AAA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.98 238.398C168.468 228.896 174.76 219.905 184.205 218.071C194.413 216.089 204.148 223.217 205.34 233.547L215.847 324.592C216.878 333.522 210.298 341.527 201.338 342.246C193.07 342.909 185.684 337.1 184.381 328.909L169.98 238.398Z",
    fill: "#AC725D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 95,
    width: 85,
    height: 87,
    rx: 27,
    fill: "#F0AAA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.215 171.257C209.708 162.737 207.759 154.571 206.598 151.552C206.598 151.552 211.5 135 226.5 124C241.5 113 260.695 112.9 260.695 112.9C248.112 78.6073 215.274 77.92 192.868 90.038C170.463 102.156 168.801 121.286 166.217 136.033C163.633 150.78 158.733 164.276 153.751 187.891C148.768 211.506 143.641 235.94 170.699 240.681C197.756 245.422 198.045 210.007 198.272 199.069C198.498 188.132 206.349 181.908 208.215 171.257Z",
    fill: "#6C4130"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.233 143.819L258.199 139L257.724 153.417C257.944 153.297 258.83 152.86 260.612 152.063C262.841 151.067 266.35 149.91 266.92 147.253C267.403 145 266.5 144 266.233 143.819Z",
    fill: "#F0AAA2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210.404,
    cy: 146.404,
    r: 8.40359,
    fill: "#F0AAA2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.694,
    cy: 138.516,
    rx: 1.69355,
    ry: 4.51613,
    fill: "#2D2D2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260 161C257.833 161.167 252.6 161 249 159",
    stroke: "#E47C70",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 346.296,
    y: 176.219,
    width: 5.90414,
    height: 53.0186,
    rx: 2,
    transform: "rotate(25.0815 346.296 176.219)",
    fill: "#484848"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379 105.176C379 128.372 360.196 147.176 337 147.176C313.804 147.176 295 128.372 295 105.176C295 81.9798 313.804 63.1758 337 63.1758C360.196 63.1758 379 81.9798 379 105.176Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.706 107.687L332.904 121.235L355.529 96.5293",
    stroke: "#3A7EFC",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.114 159C337.345 160.333 335.42 160.333 334.65 159L324.742 141.838C323.972 140.505 324.934 138.838 326.474 138.838L346.291 138.838C347.83 138.838 348.793 140.505 348.023 141.838L338.114 159Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.999 248.883L299 262.498L278.424 249.795C299.679 236.842 311.547 224.82 314.768 222.932C318.793 220.572 325.659 222.658 327.135 223.058C328.76 223.499 328.343 222.911 328.76 222.503C330.699 220.219 334.43 212.757 337.843 209.183C342.108 204.715 345.162 204.892 346.323 205.195C347.252 205.437 347.383 205.885 347.333 206.078C343.602 212.855 337.975 228.8 337.319 230.365C336.663 231.93 335.767 232.75 335.401 232.965L312.999 248.883Z",
    fill: "#F0AAA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 321.827C223.568 313.848 219.157 296.912 218.474 289.441L197.834 295.378L197.649 328.97L216.502 340.699L235.747 321.827Z",
    fill: "#AC725D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.501 209.498L326.56 213.452C327.14 214.566 327.163 215.888 326.622 217.022L319.962 230.982C319.364 232.235 318.159 233.089 316.778 233.237L314.386 233.493C310.874 233.869 308.633 229.841 310.806 227.055L324.501 209.498Z",
    fill: "#F0AAA2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction5);
export default __webpack_public_path__ + "static/media/ImgIntroduction5.90e549bb642fa53125539295e1ed4861.svg";
export { ForwardRef as ReactComponent };